import { Briefcase, CheckCircle, Clock } from "lucide-react";
import React from "react";

export type ProjectTab = "available" | "pending" | "my_projects";

interface ProjectTabsProps {
  activeTab: ProjectTab;
  onTabChange: (tab: ProjectTab) => void;
  counts: {
    available: number;
    pending: number;
    myProjects: number;
  };
}

const ProjectTabs: React.FC<ProjectTabsProps> = ({
  activeTab,
  onTabChange,
  counts,
}) => {
  // const tabs: { key: ProjectTab; label: string; count: number }[] = [
  //   { key: "available", label: "Available", count: counts.available },
  //   { key: "pending", label: "Pending", count: counts.pending },
  //   { key: "my_projects", label: "My Projects", count: counts.myProjects },
  // ];

  const tabs = [
    {
      id: "available" as const,
      label: "Available",
      icon: Briefcase,
      count: counts.available,
    },
    {
      id: "pending" as const,
      label: "Pending",
      icon: Clock,
      count: counts.pending,
    },
    {
      id: "my_projects" as const,
      label: "My Projects",
      icon: CheckCircle,
      count: counts.myProjects,
    },
  ];

  return (
    <div className="inline-flex items-center p-1 bg-gray-100 rounded-xl">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
            activeTab === tab.id
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          <tab.icon className="w-4 h-4" />
          <span className="hidden sm:inline">{tab.label}</span>
          <span
            className={`px-2 py-0.5 rounded-full text-xs font-medium ${
              activeTab === tab.id
                ? "bg-[#8B52FF]/10 text-[#8B52FF]"
                : "bg-gray-200 text-gray-500"
            }`}
          >
            {tab.count}
          </span>
        </button>
      ))}
    </div>
  );
};

export default ProjectTabs;
